import React from 'react';
import cs from 'classnames';
import {push as changeURL} from 'react-router-redux';

import Button from '~/components/common/Button';
import store from '~/store';
import {regInputNumber} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {track} from '~/misc/metrics';
import {centTo$} from '~/misc/formatMoney';
import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

import sharedCss from '../../MyAccount/share.css';
import css from './index.css';
import processCss from '../index.css';

class SelectProduction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 2,
      planModes: [],
      formData: {},
      formControl: {
      },
    };
    this.goToNext = this.goToNext.bind(this);
    this.changePlan = this.changePlan.bind(this);
    this.reduceSeatNum = this.reduceSeatNum.bind(this);
    this.changeMountInput = this.changeMountInput.bind(this);
    this.addSeatNum = this.addSeatNum.bind(this);
    this.goToBack = this.goToBack.bind(this);
    this.judgeCanclickOrNot = this.judgeCanclickOrNot.bind(this);
  }
  componentWillMount() {
    const {totalUsers} = this.props.account.userInfo.data;
    window.scrollTo(0, 0);
    this.props.changeNavItem(this.state.currentStep);

    // const data = Object.assign({}, this.props.parentState.formData.step2.formData);

    const planModesData = this.props.hp.hpPlanInfo.data || '';
    const seatNum = this.props.parentState.formData.step2.formData
      ? this.props.parentState.formData.step2.formData.product.seat_num
      : (totalUsers ? totalUsers : 1);

    return this.setState({
      planModes: planModesData,
      formData: {
        plan: 0,
        product: {
          seat_num: seatNum,
          origin_price: planModesData[0].origin_price,
          show_name: planModesData[0].show_name,
          discount_price: planModesData[0].discount_price,
          pay_option: {
            key: planModesData[0].key || '',
          },
          show_description: planModesData[0].show_description
        },
      },
    });
  }

  render() {
    const planModes = this.state.planModes;
    const totalPrice = this.state.formData.product.discount_price * Number(this.state.formData.product.seat_num);
    const showOther = this.state.formData.product.pay_option.key.split('_').length > 3 ? true : false;
    const myFun = (description, num) => {
      return (description || '').toString().replace(/{[0-9]*}/g, value => 
        centTo$(Number(value.replace(/\D/g, '')) * Number(num))
      )
    }
    return (
      <div className={css.productWrap}>
        <div>
          <div className={css.tit}>Plan</div>
        </div>
        <div className={cs(css.plansPattern)}>
          <div className={cs(sharedCss.table)}>
            <div className={cs(sharedCss.thead)}>
              <div className={cs(sharedCss.tr)}>
                {(planModes.length > 1) && <div className={cs(sharedCss.th)} />}
                <div className={
                  (planModes.length > 1)
                    ? cs(sharedCss.th, css.quart)
                    : cs(sharedCss.th, css.trisection)
                }
                >Package</div>
                <div className={
                  (planModes.length > 1)
                    ? cs(sharedCss.th, css.quart)
                    : cs(sharedCss.th, css.trisection)
                }
                >Billing</div>
                <div className={
                  (planModes.length > 1)
                    ? cs(sharedCss.th, css.quart)
                    : cs(sharedCss.th, css.trisection)
                }
                >Price</div>
              </div>
            </div>
            <div className={cs(sharedCss.tbody, css.tbody)}>
              {planModes.map((item, index) => (
                <label className={cs(sharedCss.tr, css.tr, css.label)} key={index}>
                  {(planModes.length > 1) && (
                    <div className={cs(sharedCss.td)}>
                      <input
                        name='planMode'
                        type='radio'
                        data-plan={index}
                        checked = {
                          this.state.formData.plan == index ? 'checked' : ''
                        }
                        onClick={this.changePlan}
                      />
                    </div>
                  )}
                  {item.grade_name
                    ? <div className={cs(sharedCss.td)}>
                      { item.grade_name }
                    </div>
                    : <div className={cs(sharedCss.td)} />
                  }
                  {item.show_name
                    ? (<div className={cs(sharedCss.td, css.red)}>
                      { item.show_name }
                      </div>)
                    : <div className={cs(sharedCss.td)} />
                  }
                  {item.show_description
                    ? <div className={cs(sharedCss.td, css.red)}>{ myFun(item.show_description, 1) }</div>
                    : <div className={cs(sharedCss.td)} />
                  }
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className={css.footer}>
          <div className={css.neadTopay}>
            <div className={css.seatMotionWrap}>
              <div className={cs(css.flex, css.userWrap)}>
                Users:
                <div className={css.seatInputWrap}>
                  <span
                    onClick={ () => {
                      if (this.judgeCanclickOrNot()) {
                        this.reduceSeatNum();
                      }
                    }}
                    className={cs(css.numBtn, css.numBtnLeft, !this.judgeCanclickOrNot() && css.noDrop)}
                  >_</span>
                  <input
                    className={css.userNum}
                    value={this.state.formData.product.seat_num}
                    type='number'
                    readOnly='readonly'
                    // onChange={this.changeMountInput}
                    // onBlur={this.changeMountInput}
                  />
                  <span onClick={this.addSeatNum} className={cs(css.numBtn, css.numBtnRight)}>+</span>
                  {this.state.formControl.seat_num
                    && this.state.formControl.seat_num.error
                    && (<span className={processCss.errorTips}>
                      {this.state.formControl.seat_num.error}
                    </span>)
                  }
                </div>
              </div>
            </div>

            <div className={css.flex}>
              Price:
              <span className={css.strong}>
                {
                  myFun(this.state.formData.product.show_description, this.state.formData.product.seat_num)
                }
              </span>
            </div>
          </div>
          <div className={processCss.btnWrap}>
            <Button onClick={this.goToBack} className={cs(processCss.wide)} mods={['large']} >Back</Button>
            <Button
              onClick={this.goToNext}
              className={cs(processCss.marginLef, processCss.wide)}
              mods={['large', 'action']}
            >Next</Button>
          </div>
        </div>
      </div>
    );
  }
  judgeCanclickOrNot() {
    const {accountLevel, free} = this.props.account;
    const {totalUsers} = this.props.account.userInfo.data;
    const {seat_num} = this.state.formData.product;
    if ((parseInt(accountLevel) > parseInt(free)) && (seat_num <= totalUsers)) {
      return false;
    }
    return true;
  }
  goToBack() {
    this.props.changeStep(this.state.currentStep - 1);
    setTimeout(() => {
      this.props.setStepData(this.state.currentStep, this.state);
      store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
    }, 300);
  }

  changePlan(e) {
    const plan = Number(e.target.dataset.plan);
    if (plan === this.state.formData.plan) {
      return false;
    }
    const planArr = this.state.planModes;

    return this.setState({
      formData: {
        ...this.state.formData,
        product: Object.assign(this.state.formData.product, {
          origin_price: planArr[plan].origin_price,
          show_name: planArr[plan].show_name,
          discount_price: planArr[plan].discount_price,
          pay_option: {
            key: planArr[plan].key || '',
          },
          show_description: planArr[plan].show_description
        }),
        plan: plan,
      },
    });
  }

  changeMountInput(e) {
    const value = e.target.value;

    if (regInputNumber.test(value)) {
      return this.setState({
        formData: {
          ...this.state.formData,
          product: Object.assign(this.state.formData.product, {seat_num: value}),
        },
        formControl: {
          ...this.state.formControl,
          ['seat_num']: {},
        },
      });
    }
    return this.setState({
      formData: {
        ...this.state.formData,
        product: Object.assign(this.state.formData.product, {seat_num: value}),
      },
      formControl: {
        ...this.state.formControl,
        ['seat_num']: {
          error: errorInfoConfig.seatNum.wrong,
          onClick: false,
        },
      },
    });
  }

  reduceSeatNum() {
    const currentSeatNum = Number(this.state.formData.product.seat_num) - 1;

    if (currentSeatNum > 0) {
      this.setState({
        formData: {
          ...this.state.formData,
          product: Object.assign(this.state.formData.product, {seat_num: currentSeatNum}),
        },
      });
    }
  }

  addSeatNum() {
    const currentSeatNum = Number(this.state.formData.product.seat_num) + 1;

    let product = Object.assign(this.state.formData.product, {seat_num: currentSeatNum});
    return this.setState({
      formData: Object.assign(this.state.formData, product),
      formControl: {
        ...this.state.formControl,
        ['seat_num']: {},
      },
    });
  }

  goToNext() {
    track('payment', {'product selection - 2': 1});
    this.props.changeStep(this.state.currentStep + 1);
    setTimeout(() => {
      this.props.setStepData(this.state.currentStep, this.state);
      store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
    }, 500);
  }
}

export default SelectProduction;



// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/SelectProduct/index.js